import { useDispatch } from "react-redux";

import { Target } from "../../store/Session/SessionModel";
import sessionSlice from "../../store/Session/SessionSlice";

import "./style.css";

interface Props {
  target: Target;
}

const ToggleTarget = ({ target }: Props): JSX.Element => {
  const dispatch = useDispatch();

  const setTargetIsActive = (target: Target) => {
    dispatch(
      sessionSlice.actions.setTargetIsActive({
        isActive: !target.isActive,
        targetId: target.targetId,
      })
    );
  };

  return (
    <div
      className={`toggle-club club-toggle-${target.isActive}`}
      style={{ backgroundColor: target.isActive ? "#214ECC" : "#60626980" }}
      onClick={() => setTargetIsActive(target)}
    >
      <div
        className={`circle-club-color  ${
          !target.isActive ? "club-inactive" : "club-active"
        }`}
        style={{ backgroundColor: "#fff" }}
      >
        <div className="club-icon"></div>
      </div>
    </div>
  );
};

export default ToggleTarget;
